import React from 'react';
import styled from '@emotion/styled';

type RadioProps = {
  name: string;
  value: string;
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  label?: string;
  disabled?: boolean;
  className?: string;
};

const RadioWrapper = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  user-select: none;
  position: relative;
`;

const HiddenInput = styled.input`
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;

  &:focus-visible + span {
    outline: 2px solid #5e84ed;
    outline-offset: 2px;
  }

  &:disabled + span {
    opacity: 0.6;
    cursor: not-allowed;
  }

  &:disabled ~ span {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

const OuterCircle = styled.span`
  width: 20px;
  height: 20px;
  border: 2px solid #b7bdcb;
  border-radius: 50%;
  display: grid;
  place-items: center;
  transition: border-color 0.15s ease;
`;

const InnerCircle = styled.span<{ checked: boolean }>`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #5e84ed;
  transform: scale(${(props) => (props.checked ? 1 : 0)});
  transition: transform 0.15s ease;
`;

const LabelText = styled.span`
  font-size: 14px;
`;

export const RadioButton: React.FC<RadioProps> = ({
  name,
  value,
  checked,
  onChange,
  label,
  disabled,
  className,
}) => {
  const id = `${name}-${value}`;
  return (
    <RadioWrapper htmlFor={id} className={className}>
      <HiddenInput
        type="radio"
        id={id}
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
      <OuterCircle>
        <InnerCircle checked={checked} />
      </OuterCircle>
      {label && <LabelText>{label}</LabelText>}
    </RadioWrapper>
  );
};
